import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Cookie } from 'lucide-react';

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--cream-white)' }}>
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 
            className="text-2xl font-bold"
            style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)' }}
          >
            Cookie-Richtlinie
          </h1>
          <Button 
            variant="outline"
            onClick={() => navigate('/')}
            className="flex items-center gap-2"
            style={{ borderColor: 'var(--warm-gray)', color: 'var(--charcoal)' }}
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Button>
        </nav>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center justify-center mb-8">
          <Cookie className="w-16 h-16" style={{ color: 'var(--warm-sage)' }} />
        </div>

        <div className="prose prose-lg max-w-none" style={{ color: 'var(--charcoal)' }}>
          <p className="text-sm mb-8" style={{ color: 'var(--warm-gray)' }}>
            Stand: Januar 2025
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            1. Was sind Cookies?
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Cookies sind kleine Textdateien, die auf Ihrem Endgerät (Computer, Tablet, Smartphone) gespeichert werden, wenn Sie eine Website besuchen. Sie ermöglichen es der Website, Ihr Gerät zu erkennen und bestimmte Informationen über Ihre Nutzung zu speichern.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            2. Welche Cookies verwenden wir?
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Unsere Website verwendet ausschliesslich technisch notwendige Cookies, die für den Betrieb der Website unerlässlich sind:
          </p>

          <h3 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '22px', marginBottom: '12px', marginTop: '24px' }}>
            Technisch notwendige Cookies
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '12px' }}>
              <strong>Spracheinstellung (language)</strong><br />
              Zweck: Speichert Ihre bevorzugte Sprache (Deutsch oder Englisch)<br />
              Speicherdauer: Unbegrenzt (bis Sie Ihren Browser-Cache löschen)<br />
              Typ: LocalStorage
            </li>
          </ul>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            3. Keine Tracking-Cookies
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wir verwenden <strong>keine</strong> Tracking-Cookies, Analytics-Tools oder Cookies von Drittanbietern. Ihre Privatsphäre ist uns wichtig, daher verzichten wir bewusst auf:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Google Analytics oder ähnliche Analysedienste</li>
            <li style={{ marginBottom: '8px' }}>Social Media Tracking</li>
            <li style={{ marginBottom: '8px' }}>Werbe-Cookies</li>
            <li style={{ marginBottom: '8px' }}>Remarketing-Tools</li>
          </ul>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            4. Verwaltung von Cookies
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Sie können Cookies in Ihren Browser-Einstellungen verwalten und löschen:
          </p>

          <h3 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '22px', marginBottom: '12px', marginTop: '24px' }}>
            Google Chrome
          </h3>
          <p style={{ lineHeight: '1.8', marginBottom: '16px' }}>
            Einstellungen → Datenschutz und Sicherheit → Cookies und andere Website-Daten
          </p>

          <h3 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '22px', marginBottom: '12px', marginTop: '24px' }}>
            Mozilla Firefox
          </h3>
          <p style={{ lineHeight: '1.8', marginBottom: '16px' }}>
            Einstellungen → Datenschutz & Sicherheit → Cookies und Website-Daten
          </p>

          <h3 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '22px', marginBottom: '12px', marginTop: '24px' }}>
            Safari
          </h3>
          <p style={{ lineHeight: '1.8', marginBottom: '16px' }}>
            Einstellungen → Datenschutz → Cookies und Website-Daten
          </p>

          <h3 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '22px', marginBottom: '12px', marginTop: '24px' }}>
            Microsoft Edge
          </h3>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Einstellungen → Cookies und Websiteberechtigungen → Cookies und Websitedaten
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            5. Auswirkungen der Cookie-Verwaltung
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wenn Sie Cookies in Ihrem Browser blockieren oder löschen:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Spracheinstellung:</strong> Die Website wird bei jedem Besuch in der Standardsprache (Deutsch) angezeigt
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Funktionalität:</strong> Alle anderen Funktionen bleiben uneingeschränkt verfügbar
            </li>
          </ul>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            6. Externe Dienste
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Unsere Website bindet keine externen Dienste ein, die Cookies setzen könnten (z.B. Google Fonts, YouTube-Videos, Social Media Plugins). Dadurch wird Ihre Privatsphäre maximal geschützt.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            7. Datenschutz
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Die durch Cookies gespeicherten Informationen werden ausschliesslich lokal auf Ihrem Gerät gespeichert. Sie werden nicht an uns oder Dritte übertragen. Weitere Informationen zum Datenschutz finden Sie in unserer <a href="/privacy-policy" style={{ color: 'var(--lv-brown)', textDecoration: 'underline' }}>Datenschutzerklärung</a>.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            8. Änderungen dieser Cookie-Richtlinie
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wir behalten uns vor, diese Cookie-Richtlinie bei Bedarf zu aktualisieren, um Änderungen in unserer Praxis oder aus rechtlichen Gründen zu berücksichtigen. Die aktuelle Version ist stets auf unserer Website verfügbar.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            9. Kontakt
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Bei Fragen zu unserer Cookie-Richtlinie kontaktieren Sie uns bitte:<br /><br />
            E-Mail: contact@lvluxury.ch<br />
            Telefon: +41 41 543 36 77
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
